// mobile-nav.js

let mobileSubNav = {
    init:function () {
        $('.mobile-interior-nav-control').on('click', mobileSubNav.overlayToggle);
    },


    overlayToggle:function() {
        if ($('.mobile-subnav-outer').hasClass('open')) {
            mobileSubNav.overlayHide()
        } else {
            mobileSubNav.overlayShow()
        }
    },
    overlayHide:function() {
        $('.mobile-subnav-outer').removeClass('open')
    },
    overlayShow:function() {
        $('.mobile-subnav-outer').addClass('open')
    }
}; //obj

export default mobileSubNav
